<template>
  <v-row class="pa-6"
         style="position: absolute; bottom: 0; width: 100%">
    <v-col class="d-flex justify-space-between align-center" cols="6">
      <p class="body-1 mb-0">
        <v-icon :sixe="24">mdi-translate</v-icon>&nbsp;{{ $t('lang') }}
      </p>
    </v-col>
    <v-col class="d-flex justify-space-between align-center" cols="6">
      <div>
        <v-btn @click="changeLocale('ru')" icon>RU</v-btn>
      </div>
      <div>
        <v-btn @click="changeLocale('de')" icon>DE</v-btn>
      </div>
      <div>
        <v-btn @click="changeLocale('en')" icon>EN</v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { localize } from 'vee-validate';
export default {
  name: "LocalesComponent",
  mounted() {
    this.changeLocale(this.$cookies.isKey('app_lang') ? this.$cookies.get('app_lang') : 'de');
  },
  methods: {
    changeLocale(lang) {
      this.$cookies.set('app_lang', lang, 86400 * 365)
      this.$vuetify.lang.current = lang;
      this.$root.$i18n.locale = lang;
      import(`vee-validate/dist/locale/${lang}`).then(locale => {
        localize(lang, locale);
        document.documentElement.lang = lang;
      });
    }
  }
}
</script>

<style scoped>

</style>
